module.exports = __webpack_public_path__ + "static/img/stars.3436b32.jpg";